import { dispatchCartFetch } from '@theme/seal-dispatch-snapshot';
import { CartAddEvent } from '@theme/events';

const ADD_BUTTON_SELECTOR = '[data-seal-cart-second-unit-add]';

class SealCartSecondUnitOffer {
  constructor() {
    document.addEventListener('click', this.handleClick);
  }

  handleClick = async (event) => {
    const button = event.target instanceof Element ? event.target.closest(ADD_BUTTON_SELECTOR) : null;
    if (!(button instanceof HTMLButtonElement) || button.disabled) return;

    event.preventDefault();

    const variantId = button.dataset.variantId;
    if (!variantId) return;

    this.setButtonState(button, 'loading');

    try {
      const response = await dispatchCartFetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: 1,
            },
          ],
          sections: this.getCartSectionIds().join(','),
          sections_url: window.location.pathname,
        }),
      });

      const data = await response.json();

      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || 'Second unit add failed');
      }

      this.setButtonState(button, 'added');

      button.dispatchEvent(
        new CartAddEvent(data, `seal-cart-second-unit-${variantId}`, {
          source: 'seal-cart-second-unit-offer',
          itemCount: 1,
          variantId,
          sections: data.sections,
        })
      );
    } catch (error) {
      console.error(error);
      this.setButtonState(button, 'error');

      window.setTimeout(() => {
        this.setButtonState(button, 'idle');
      }, 1800);
    }
  };

  getCartSectionIds() {
    return [...document.querySelectorAll('cart-items-component')]
      .map((component) => component.dataset.sectionId)
      .filter(Boolean);
  }

  setButtonState(button, state) {
    const label = button.querySelector('[data-seal-cart-second-unit-label]');
    const defaultLabel = button.dataset.label || '';
    const loadingLabel = button.dataset.loadingLabel || defaultLabel;
    const errorLabel = button.dataset.errorLabel || defaultLabel;

    button.classList.toggle('is-loading', state === 'loading');
    button.classList.toggle('is-error', state === 'error');
    button.disabled = state === 'loading';

    if (!label) return;

    if (state === 'loading') {
      label.textContent = loadingLabel;
    } else if (state === 'error') {
      label.textContent = errorLabel;
    } else {
      label.textContent = defaultLabel;
    }
  }
}

if (!window.sealCartSecondUnitOffer) {
  window.sealCartSecondUnitOffer = new SealCartSecondUnitOffer();
}
